// packages/main/app/web/components-v2/UnifiedImageDialog/FreeImagesTab.tsx
import * as Api from '@ViewModels';
import { PixabayImageBrowser } from '../PixabayImageBrowser';
import { DefaultHighResHorizontalPixabayImageSearchOptions } from '../../components/MediaChooser/models';

interface FreeImagesTabProps {
	onImageSelected: (image: Api.IFileAttachment) => void;
	onEditWithAI: (image: Api.IFileAttachment) => void;
	content?: string; // Post content for AI-suggested images
	addToLibrary?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

export function FreeImagesTab({
	onImageSelected,
	onEditWithAI,
	content,
	addToLibrary,
	impersonationContext,
}: FreeImagesTabProps) {
	return (
		<PixabayImageBrowser
			onImageSelected={onImageSelected}
			onEditWithAI={onEditWithAI}
			content={content}
			imageSearchOptions={DefaultHighResHorizontalPixabayImageSearchOptions}
			addToLibrary={addToLibrary}
			impersonationContext={impersonationContext}
		/>
	);
}
